<template>
  <div class="column content-box settings--content">
    <label class="step-title">{{
      $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.FAQS.TITLE')
    }}</label>
    <div v-for="(item, index) in faqs" :key="index" class="label-entry">
      <accordion-item
        :title="itemTitle(item)"
        :is-open="openAccordions[index]"
        @click="toggleAccordion(index)"
      >
        <label>
          {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.FAQS.LABEL_QUESTION') }}
          <input
            v-model.trim="item.question"
            type="text"
            :placeholder="
              $t(
                'INTEGRATION_SETTINGS.ASSISTENT.FORM.FAQS.PLACEHOLDER_QUESTION'
              )
            "
          />
        </label>
        <label>
          {{ $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.FAQS.LABEL_ANSWER') }}
          <textarea
            v-model.trim="item.answer"
            class="textlong"
            :placeholder="
              $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.FAQS.PLACEHOLDER_ANSWER')
            "
          />
        </label>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          size="small"
          type="button"
          @click="removeItem(index)"
        >
          {{
            $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.FAQS.BUTTON_REMOVE_TEXT')
          }}
        </woot-button>
      </accordion-item>
    </div>
    <woot-button
      type="button"
      class="button--add-domain"
      icon="add"
      color-scheme="success"
      variant="smooth"
      size="small"
      @click="addItem"
    >
      <span>{{
        $t('INTEGRATION_SETTINGS.ASSISTENT.FORM.FAQS.BUTTON_ADD_TEXT')
      }}</span>
    </woot-button>

    <div class="tab-footer">
      <woot-submit-button
        :loading="isSaving"
        :button-text="$t('INTEGRATION_SETTINGS.ASSISTENT.UPDATE.BUTTON_TEXT')"
        @click="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import assistentTabMixin from '../../mixins/assistentTabMixin';
import AccordionItem from '../../../profile/components/AccordionItem.vue';

const safeParse = val => {
  if (!val) return [];
  if (typeof val === 'object') return val;
  try {
    return JSON.parse(val);
  } catch (e) {
    return [];
  }
};

export default {
  components: { AccordionItem },
  mixins: [assistentTabMixin],
  data() {
    const faqs = safeParse(this.assistent.faqs).map(item => ({
      question: item.question || '',
      answer: item.answer || '',
    }));
    return {
      faqs,
      openAccordions: faqs.map(() => false),
    };
  },
  methods: {
    itemTitle(item) {
      if (item.question) {
        return `${this.$t(
          'INTEGRATION_SETTINGS.ASSISTENT.FORM.FAQS.ITEM_PREFIX'
        )} ${item.question}`;
      }
      return this.$t('INTEGRATION_SETTINGS.ASSISTENT.FORM.FAQS.NEW_ITEM_TITLE');
    },
    toggleAccordion(index) {
      this.$set(this.openAccordions, index, !this.openAccordions[index]);
    },
    addItem() {
      this.faqs.push({ question: '', answer: '' });
      this.openAccordions = this.openAccordions.map(() => false);
      this.openAccordions.push(true);
    },
    removeItem(index) {
      this.faqs.splice(index, 1);
      this.openAccordions.splice(index, 1);
    },
    async onSubmit() {
      const mappedFaqs = this.faqs
        .filter(
          item =>
            item.question &&
            item.question.trim() &&
            item.answer &&
            item.answer.trim()
        )
        .map(item => ({
          question: item.question.trim(),
          answer: item.answer.trim(),
        }));

      await this.saveAssistent({ faqs: JSON.stringify(mappedFaqs) });
    },
  },
};
</script>

<style scoped lang="scss">
@import './tabs-shared.scss';
</style>
